import { render, staticRenderFns } from "./Sirens.vue?vue&type=template&id=e2c83c6e&scoped=true"
import script from "./Sirens.vue?vue&type=script&lang=js"
export * from "./Sirens.vue?vue&type=script&lang=js"
import style0 from "./Sirens.vue?vue&type=style&index=0&id=e2c83c6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2c83c6e",
  null
  
)

export default component.exports